import Fullscreen from "@coworker/apprestructured/src/task-management/components/Fullscreen/Fullscreen";
import FullscreenContent from "@coworker/apprestructured/src/task-management/components/Fullscreen/FullscreenContent/FullscreenContent";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import Linkbar from "@coworker/apprestructured/src/shared/components/Linkbar/Linkbar";
import Breadcrumb from "../../shared/Breadcrumb/Breadcrumb";
import CustomTaskDescriptionDemo from "../ComponentDemoPage/demos/CustomTaskDescriptionDemo";
import TitledTextDemo from "../ComponentDemoPage/demos/TitledTextDemo";
import TitledTextWithModalDemo from "../ComponentDemoPage/demos/TitledTextWithModalDemo";
import TitledBoxedTextDemo from "../ComponentDemoPage/demos/TitledBoxedTextDemo";
import TitledBoxedTextWithModalDemo from "../ComponentDemoPage/demos/TitledBoxedTextWithModalDemo";
import TitledHeadingTextDemo from "../ComponentDemoPage/demos/TitledHeadingTextDemo";
import TitledTextAreaDemo from "../ComponentDemoPage/demos/TitledTextAreaDemo";
import TextModalDemo from "../ComponentDemoPage/demos/TextModalDemo";
import AddLinksDemo from "../ComponentDemoPage/demos/AddLinksDemo";
import SelectItemDemo from "../ComponentDemoPage/demos/SelectItemDemo";
import SelectItemSheetDemo from "../ComponentDemoPage/demos/SelectItemSheetDemo";
import SelectMultipleItemDemo from "../ComponentDemoPage/demos/SelectMultipleItemDemo";
import SelectWithDescriptionAndTagsDemo from "../ComponentDemoPage/demos/SelectWithDescriptionAndTagsDemo";
import SwitchDemo from "../ComponentDemoPage/demos/SwitchDemo";
import AssignToDemo from "../ComponentDemoPage/demos/AssignToDemo";
import TaskScheduleDemo from "../ComponentDemoPage/demos/TaskScheduleDemo";
import AddLocationDemo from "../ComponentDemoPage/demos/AddLocationDemo";
import PickupAndRefillLocationDemo from "../ComponentDemoPage/demos/PickupAndRefillLocationDemo";
import RefillQuantityDemo from "../ComponentDemoPage/demos/RefillQuantityDemo";
import ListItemWithControlsDemo from "../ComponentDemoPage/demos/ListItemWithControlsDemo";
import MediaGroupedListViewDemo from "../ComponentDemoPage/demos/MediaGroupedListViewDemo";
import SegmentedControlCreatorFragmentDemo from "../ComponentDemoPage/demos/SegmentedControlCreatorFragmentDemo";
import DecisionWithModalDemo from "../ComponentDemoPage/demos/DecisionWithModalDemo";
import styles from "../shared.module.css";

function InputsPage() {
  return (
    <Fullscreen>
      <Linkbar currentLabel="Input & Forms" currentAsH1 />
      <FullscreenContent className={styles["content"]}>
        <Breadcrumb
          items={[
            { label: "Components", path: "/task-management-components" },
            { label: "Input & Forms" },
          ]}
        />

        <FixaText tagName="h2" textStyle="Heading.XL">
          Input & Form Components
        </FixaText>

        <FixaText tagName="h3" textStyle="Heading.L">
          Text Inputs
        </FixaText>
        <CustomTaskDescriptionDemo />
        <TitledTextDemo />
        <TitledTextWithModalDemo />
        <TitledBoxedTextDemo />
        <TitledBoxedTextWithModalDemo />
        <TitledHeadingTextDemo />
        <TitledTextAreaDemo />
        <TextModalDemo />
        <AddLinksDemo />

        <FixaText tagName="h3" textStyle="Heading.L">
          Selection Controls
        </FixaText>
        <SelectItemDemo />
        <SelectItemSheetDemo />
        <SelectWithDescriptionAndTagsDemo />
        <SelectMultipleItemDemo />
        <SegmentedControlCreatorFragmentDemo />
        <SwitchDemo />
        <DecisionWithModalDemo />

        <FixaText tagName="h3" textStyle="Heading.L">
          Specialized Inputs
        </FixaText>
        <AssignToDemo />
        <TaskScheduleDemo />
        <AddLocationDemo />
        <PickupAndRefillLocationDemo />
        <RefillQuantityDemo />
        <ListItemWithControlsDemo />
        <MediaGroupedListViewDemo />
      </FullscreenContent>
    </Fullscreen>
  );
}

export default InputsPage;
